import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { HOME_STEPS } from "../lib/site";

const HomeJourney = () => (
    <section
        data-testid="home-journey-section"
        className="relative border-y border-white/10 bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    HOW IT WORKS
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    01 — 05
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="journey-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                From plans to informed decisions
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.ol
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="relative mt-16 grid gap-10 lg:grid-cols-5 lg:gap-4"
            >
                <span
                    aria-hidden="true"
                    className="absolute left-[22px] top-2 h-[calc(100%-16px)] w-px bg-white/10 lg:hidden"
                />
                <span
                    aria-hidden="true"
                    className="absolute left-0 right-0 top-[22px] hidden h-px bg-white/10 lg:block"
                />
                {HOME_STEPS.map((step) => (
                    <motion.li
                        key={step.n}
                        variants={fadeUp}
                        data-testid={`home-step-${step.n}`}
                        className="relative flex gap-5 pl-14 lg:flex-col lg:items-start lg:gap-0 lg:pl-0"
                    >
                        <span className="absolute left-0 top-0 z-10 flex h-11 w-11 items-center justify-center border border-white/15 bg-ink font-mono text-[13px] text-white lg:static lg:mb-5">
                            {step.n}
                        </span>
                        <div>
                            <h3 className="text-[16px] font-semibold text-white">
                                {step.title}
                            </h3>
                            <p className="mt-2 max-w-[230px] text-[14px] leading-relaxed text-cad lg:max-w-none">
                                {step.copy}
                            </p>
                        </div>
                    </motion.li>
                ))}
            </motion.ol>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <Link
                    to="/how-it-works"
                    data-testid="home-journey-link"
                    className="group mt-14 inline-flex items-center gap-2 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                >
                    See How It Works
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
            </motion.div>
        </div>
    </section>
);

export default HomeJourney;
